import EnvSettings from "./EnvSettings";
import UsersApi from "./UsersApi";

const baseUrl = EnvSettings.url;

const CreatePostUrl = "CreatePost";
const GetAllPostsUrl = "GetAllPosts";
const GetAllCommentsUrl = "GetAllComments";
const CreatePostCommentUrl = "CreatePostComment";
const LikePostUrl = "LikePost";
const UnlikePostUrl = "UnlikePost";

const FeedApi = {
	createPostComment: async ({ content, userId, postId }) => {
		try {
			const res = await fetch([baseUrl, CreatePostCommentUrl].join(""), {
				method: "POST",
				headers: {
					Authorization: `Bearer ${UsersApi.GetToken()}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					content,
					userId,
					postId,
				}),
			});
			return await res.json();
		} catch (err) {
			console.error(err);
			return {
				status: { success: false },
			};
		}
	},
	createPost: async ({ content, userId, imageUrls, isImportant }) => {
		try {
			const res = await fetch([baseUrl, CreatePostUrl].join(""), {
				method: "POST",
				headers: {
					Authorization: `Bearer ${UsersApi.GetToken()}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					content,
					userId,
					isImportant,
					imageUrls,
				}),
			});
			return await res.json();
		} catch (err) {
			console.error(err);
			return {
				status: { success: false },
			};
		}
	},
	getAllPosts: async (body) => {
		try {
			const res = await fetch([baseUrl, GetAllPostsUrl].join(""), {
				method: "POST",
				headers: {
					Authorization: `Bearer ${UsersApi.GetToken()}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify(body),
			});
			return await res.json();
		} catch (err) {
			console.error(err);
			return {
				status: { success: false },
			};
		}
	},
	getAllComments: async ({ postId }) => {
		try {
			const res = await fetch([baseUrl, GetAllCommentsUrl].join(""), {
				method: "POST",
				headers: {
					Authorization: `Bearer ${UsersApi.GetToken()}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ postId }),
			});
			return await res.json();
		} catch (err) {
			console.error(err);
			return {
				status: { success: false },
			};
		}
	},
	likePost: async ({ id, userId }) => {
		try {
			const res = await fetch([baseUrl, LikePostUrl].join(""), {
				method: "POST",
				headers: {
					Authorization: `Bearer ${UsersApi.GetToken()}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ id, userId }),
			});
			return await res.json();
		} catch (err) {
			console.error(err);
			return {
				status: { success: false },
			};
		}
	},
	unlikePost: async ({ id, userId }) => {
		try {
			const res = await fetch([baseUrl, UnlikePostUrl].join(""), {
				method: "POST",
				headers: {
					Authorization: `Bearer ${UsersApi.GetToken()}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ id, userId }),
			});
			return await res.json();
		} catch (err) {
			console.error(err);
			return {
				status: { success: false },
			};
		}
	},
};

export default FeedApi;
